<div class="container-fluid p-3">

  <div class="d-flex gap-1">
    <mat-form-field appearance="outline">
      <mat-label>Session Date Range</mat-label>
      <mat-date-range-input [rangePicker]="picker">
        <input matStartDate placeholder="From date" [formControl]="startDate">
        <input matEndDate placeholder="To date" [formControl]="endDate">
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>


    <mat-form-field appearance="outline">
      <mat-label>Centre Name</mat-label>
      <mat-select [formControl]="SelectCentre" (selectionChange)="onCentreChange($event)">
        <mat-option value="All">All Centres</mat-option>
        <mat-option *ngFor="let c of (centres$ | async)" [value]="c.centreCode">
          {{ c.centreName }}
        </mat-option>
      </mat-select>
    </mat-form-field>


    <mat-form-field  appearance="outline" >
      <mat-label  >Teacher</mat-label>
      <mat-select [(value)]="mTeacher">
        <mat-option value="All">All</mat-option>
        <mat-option *ngFor="let t of teachers$ | async" [value]="t.userName">
          {{ t.userName }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Teacher Type</mat-label>
      <mat-select [(value)]="teacherType">
        <mat-option value="All">All</mat-option>
        <mat-option *ngFor="let type of teacherTypeOptions" [value]="type">{{ type }}</mat-option>
      </mat-select>
    </mat-form-field>


    <button mat-mini-fab (click)="search()" color="accent"><mat-icon>search</mat-icon></button>
    <button mat-mini-fab (click)="clearAll()" color="accent"><mat-icon>clear</mat-icon></button>

  </div>



  <div class="alert alert-warning" *ngIf="hasNoAccess">
    You do not have access to Education Observation records. Observations are visible only to
    Senior Teachers, Lead Teachers and Admin/Management, for the levels below their own.
  </div>

  <section class="card">
    <div class="ngxTableHeader">
      <ul class="header-buttons-left ms-0 mb-0">
        <li class="dropdown">
          <h2>Education Observation List</h2>
        </li>

        <li class="dropdown m-l-20">
          <label><i class="material-icons search-icon">search</i></label>
          <input placeholder="Search" type="text" class="browser-default search-field"
                 (keyup)="applyFilter($event)" aria-label="Search box">
        </li>
      </ul>

      <ul class="header-buttons mr-2">
        <li>
          <button mat-mini-fab color="primary" class="mr-2" (click)="addObservation()" permission="Education Observation" [permissionTypes]="[PermissionType.ADD, PermissionType.ALL]">
            <mat-icon class="col-white">add</mat-icon>
          </button>
        </li>
        <li>
          <button
            mat-mini-fab
            color="accent"
            (click)="downloadExcelSheet()"
            matTooltip="Download Excel"
            permission="Education Observation"
            [permissionTypes]="[PermissionType.EXCEL]"
          >
            <mat-icon>download</mat-icon>
          </button>
        </li>
      </ul>
    </div>
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z2 w-100">
      <ng-container matColumnDef="srNo">
        <th mat-header-cell *matHeaderCellDef> Sr.No. </th>
        <td mat-cell *matCellDef="let row; let i = index"> {{ i + 1 }} </td>
      </ng-container>

      <ng-container matColumnDef="sessionDate">
        <th mat-header-cell *matHeaderCellDef> Date </th>
        <td mat-cell *matCellDef="let row"> {{ row.sessionDate?.toDate() | date }} </td>
      </ng-container>

      <ng-container matColumnDef="observerName">
        <th mat-header-cell *matHeaderCellDef> Observer </th>
        <td mat-cell *matCellDef="let row"> {{ row.observerName }} </td>
      </ng-container>

      <ng-container matColumnDef="teacherName">
        <th mat-header-cell *matHeaderCellDef> Teacher </th>
        <td mat-cell *matCellDef="let row"> {{ row.teacherName }} </td>
      </ng-container>

      <ng-container matColumnDef="centreName">
        <th mat-header-cell *matHeaderCellDef> Centre </th>
        <td mat-cell *matCellDef="let row"> {{ row.centreName }} </td>
      </ng-container>
      <ng-container matColumnDef="childName">
        <th mat-header-cell *matHeaderCellDef> Child Name </th>
        <td mat-cell *matCellDef="let row">

          <!-- Has children -->
          <ng-container *ngIf="row.children?.length > 0; else noChild">

            <!-- First child always visible -->
            <span>{{ row.children[0].childName }}</span>

            <!-- More children -->
            <ng-container *ngIf="row.children.length > 1">
              <!-- Show remaining when expanded -->
              <ng-container *ngIf="row.showAllChildren">
          <span *ngFor="let item of row.children.slice(1)">
            , {{ item.childName }}
          </span>
                <a class="ms-1 cursor-pointer"
                   (click)="row.showAllChildren = false">
                  Show less
                </a>
              </ng-container>

              <!-- Collapsed state -->
              <ng-container *ngIf="!row.showAllChildren">
                <a class="ms-1 cursor-pointer"
                   (click)="row.showAllChildren = true">
                  +{{ row.children.length - 1 }} more
                </a>
              </ng-container>
            </ng-container>

          </ng-container>

          <!-- NA fallback -->
          <ng-template #noChild>
            <span class="text-muted">NA</span>
          </ng-template>

        </td>
      </ng-container>


      <ng-container matColumnDef="sessionType">
        <th mat-header-cell *matHeaderCellDef> Session </th>
        <td mat-cell *matCellDef="let row"> {{ row.sessionType }} </td>
      </ng-container>

      <ng-container matColumnDef="subject">
        <th mat-header-cell *matHeaderCellDef> Subject </th>
        <td mat-cell *matCellDef="let row"> {{ row.subject }} </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef> Actions </th>
        <td mat-cell *matCellDef="let row">
          <button mat-icon-button color="accent"
                  (click)="view(row)"
                  permission="Education Observation"
                  [permissionTypes]="[PermissionType.VIEW, PermissionType.ALL]">
            <mat-icon>visibility</mat-icon>
          </button>
          <button mat-icon-button color="primary" (click)="edit(row)"  permission="Education Observation" [permissionTypes]="[PermissionType.EDIT]">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button color="warn" (click)="delete(row.id)"  permission="Education Observation" [permissionTypes]="[PermissionType.ARCHIVE]">
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="[10,25, 50, 100, 500]" showFirstLastButtons></mat-paginator>
  </section>
</div>
